<!-- hmqm-新增出厂报告模板 （tableb版-已舍弃）-->

<template>
  <h-inspection-page :title="h_i18n('ec006c91b72265f9e0381115b71dfe72')" @inspection-update="inspectionUpdate">
    <template #hands>
      <span style="margin-right: 10px">{{ version }}</span>
      <h-button type="primary" @click="synchronizeData">{{ h_i18n('a1c90d3995ef66764d6a0734ddc21309') }}</h-button>
    </template>
    <inspection-header :title="h_i18n('ec006c91b72265f9e0381115b71dfe72')" title-height="80px">
      <template #body>
        <tr style="border: none;">
          <td colspan="6" style="border: none;">
            <div class="factory_item">
              <div class="nav_th50">
                <div class="nav_left_befor">{{ h_i18n('fd5b64ec505f303e7c052ce0d5690b21') }}</div>
                <div class="nav_right">{{ planeDetails.mtlNo }}</div>
              </div>
              <div class="nav_th50">
                <div class="nav_left">{{ h_i18n('d3d82d46881ddede6be88387fa1ecea0') }}</div>
                <div class="nav_right">{{ planeDetails.mtlName }}</div>
              </div>
            </div>
            <div class="factory_item" v-if="$route.query.type === '1'">
              <div class="nav_th50">
                <div class="nav_left_befor">{{ h_i18n('ce5c4212119d8631cfcb8ea2fed1355a') }}</div>
                <div class="nav_right">{{ planeDetails.sybName }}</div>
              </div>
              <div class="nav_th50">
                <div class="nav_left">{{ h_i18n('bc88d7f7000d6a76e90d6ceacb1b5bd3') }}</div>
                <div class="nav_right">{{ planeDetails.supplyCode }}</div>
              </div>
            </div>
          </td>
        </tr>
        <!-- <tr>
          <h-td colspan="2" title="专用号">{{ planeDetails.mtlNo }}</h-td>
          <h-td colspan="2" title="物料名称">{{ planeDetails.mtlName }}</h-td>
        </tr>
        <tr v-if="$route.query.type === '1'">
          <h-td colspan="2" title="工厂">{{ planeDetails.sybName }}</h-td>
          <h-td colspan="2" title="供应商编码">{{ $route.query.supplyCode }}</h-td>
        </tr> -->
      </template>
    </inspection-header>
    <inspection-body>
      <div class="temtable">
        <div class="table_flex center" style="font-size: 14px;background: rgb(241, 242, 248);height: 48px;">
          <div class="table_50 center">{{ h_i18n('faaadc447b1c2b1adc920d9c9aedcc25') }}</div>
          <div class="table_150 center">{{ h_i18n('222c0f1a6341c9df01ca58fc982db93b') }}</div>
          <div class="biaozun center">{{ h_i18n('a9f414ff06ac30b8644229e3010b7af0') }}</div>
          <div class="table_100 center">{{ h_i18n('4626e7457839719f5fa1b08526e5e3fd') }}</div>
          <div class="table_100 center">{{ h_i18n('0cf684d33849528278363c0e3991cb82') }}</div>
          <div class="table_100 center">AQL</div>
          <div class="table_100 center">{{ h_i18n('2b6bc0f293f5ca01b006206c2535ccbc') }}</div>
        </div>
        <div class="table_item" v-for="(item, index) in qbTableList">
          <div class="item_nav">
            <div style="float:left;text-align: left;height: 36px;display: flex;align-items: center;text-indent: 16px;font-size: 14px;">{{ h_i18n('7e217ea649098e03f615a99ae9c692a8') }}<span style="color: #1D2129;">{{ item.templateCode }}</span>{{ h_i18n('6d2c01ad47709bd98fbc4dbbcea7c841') }}<span style="color: #165DFF;">{{ item.templateName }}</span> 
              </div>
            <div style="margin-right: 20px; display: flex; align-items: center">
              <h-button type="primary" size="small" @click="addTemplateCard()" style="margin-right: 10px">{{ h_i18n('e72f6b7e684f6c9d0424c2817010a2ea') }}</h-button>
              <el-popconfirm :title="h_i18n('53d6d751de6344a0a81cf18ee1535e5a')" @confirm="deleteTemplateCard(index)">
                <template #reference>
                  <h-button type="danger" size="small">{{ h_i18n('2f4aaddde33c9b93c36fd2503f3d122b') }}</h-button>
                </template>
              </el-popconfirm>
            </div>
          </div>
          <div>
            <div class="table_flex center" v-for="(eq, ei) in item.itemList">
              <div class="table_50 center">{{ ei + 1 }}</div>
              <div class="table_150 center">
                <el-input v-model="eq.itemName" type="textarea" :rows="1"></el-input>
              </div>
              <div class="biaozun center">
                <el-input v-model="eq.remark" type="textarea" :rows="1"></el-input>
              </div>
              <div class="table_100 center">
                <el-select v-model="eq.importanceProperty" :disabled="eq.isSupply == 'N'"
                  :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')">
                  <el-option v-for="itemty in importantList" :key="itemty.valueId"
                    :label="itemty.valueName ? itemty.valueName : ' '" :value="itemty.valueId.toString()"></el-option>
                </el-select>
              </div>
              <div class="table_100 center">
                <el-select v-model="eq.checkLevel" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" :disabled="eq.isSupply == 'N'">
                  <el-option v-for="itemel in checkLevelList" :key="itemel.valueId"
                    :label="itemel.valueName ? itemel.valueName : ' '" :value="itemel.valueId.toString()"></el-option>
                </el-select>
              </div>
              <div class="table_100 center">
                <el-input v-model="eq.aqlProperty" type="textarea" :disabled="eq.isSupply == 'N'" maxlength="50"></el-input>
              </div>
              <div class="table_100 center">
                <div style="font-size: 12px;">
                  <span @click="addItem(index,ei,eq.templateName)" style="margin-right: 15px;cursor: pointer;color: blue;">{{ h_i18n('b58c7549c0246c55b9cac96383200338') }}</span>
                  <el-popconfirm :title="h_i18n('1fdc12aa8a314536edea729663996f9e')" @confirm="deleteItem(index,ei)" v-if="eq.isMust === 'N' || eq.isSupply === 'Y'">
                    <template #reference><el-button size="mini" style="padding: 0 !important;border: none !important;color: #f56c6c;">{{ h_i18n('2f4aaddde33c9b93c36fd2503f3d122b') }}</el-button></template>
                  </el-popconfirm>
                </div>
                <!-- <div style="font-size: 18px; cursor: pointer; color: blue">
                  <i class="el-icon-circle-plus-outline" @click="addItem(index, ei, eq.templateName)"
                    style="margin-right: 15px"></i>
                  <el-popconfirm title="确定删除吗？" @confirm="deleteItem(index, ei)" v-if="eq.isMust === 'N'">
                    <template #reference>
                      <i class="el-icon-delete"></i>
                    </template>
                  </el-popconfirm>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- 通用 -->
        <div class="table_item">
          <div class="item_nav">
            <div style="text-indent: 16px;color: #165DFF;font-size: 14px;">{{ h_i18n('09334806287d60f5b2bb2a3719f30fa8') }}
              <!-- 通用要求至少需要有‘认证情况’，‘有害物质’，‘包装运输、贮存’，‘标志’四项，否则可能导致海尔审核打回，请谨慎操作！ -->
              <span class="dangerColor" style="padding-left: 12px;">*{{ h_i18n('D2F491E0BEF3EAE4A07DC086C1D32184') }}</span>
            </div>
          </div>
          <div>
            <div class="table_flex center" v-for="(etim, edex) in comTableList">
              <div class="table_50 center">{{ edex + 1 }}</div>
              <div class="table_150 center">
                <el-input v-model="etim.itemName" type="textarea" :rows="1"></el-input>
              </div>
              <div class="biaozun center">
                <el-input v-model="etim.remark" type="textarea" :rows="1"></el-input>
              </div>
              <div class="table_100 center">
                <el-select v-model="etim.importanceProperty" :disabled="etim.isSupply == 'N'"
                  :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')">
                  <el-option v-for="itemty in importantList" :key="itemty.valueId"
                    :label="itemty.valueName ? itemty.valueName : ' '" :value="itemty.valueId.toString()"></el-option>
                </el-select>
              </div>
              <div class="table_100 center">
                <el-select v-model="etim.checkLevel" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" :disabled="etim.isSupply == 'N'">
                  <el-option v-for="itemel in checkLevelList" :key="itemel.valueId"
                    :label="itemel.valueName ? itemel.valueName : ' '" :value="itemel.valueId.toString()"></el-option>
                </el-select>
              </div>
              <div class="table_100 center">
                <el-input v-model="etim.aqlProperty" type="textarea" :disabled="etim.isSupply == 'N'" maxlength="50"></el-input>
              </div>
              <div class="table_100 center">
                <!-- <div style="font-size: 18px; cursor: pointer; color: blue">
                  <i class="el-icon-circle-plus-outline" @click="addItem2(edex)" style="margin-right: 15px"></i>
                  <el-popconfirm title="确定删除吗？" @confirm="deleteItem2(edex)" v-if="etim.isMust === 'N'">
                    <template #reference>
                      <i class="el-icon-delete"></i>
                    </template>
                  </el-popconfirm>
                </div> -->
                <div style="font-size: 12px;">
                  <span @click="addItem2(edex)" style="margin-right: 15px;cursor: pointer;color: blue;">{{ h_i18n('b58c7549c0246c55b9cac96383200338') }}</span>
                  <el-popconfirm :title="h_i18n('1fdc12aa8a314536edea729663996f9e')" @confirm="deleteItem2(edex)">
                    <template #reference><el-button size="mini" style="padding: 0 !important;border: none !important;color: #f56c6c;" v-if="($route.query.dataFrom =='sqm')">{{ h_i18n('2f4aaddde33c9b93c36fd2503f3d122b') }}</el-button></template>
                    <!-- <template #reference><el-button size="mini" style="padding: 0 !important;border: none !important;color: #f56c6c;" v-if="!(etim.isMust == 'Y' || ($route.query.dataFrom =='sqm' && etim.isSupply == 'N'))">{{ h_i18n('2f4aaddde33c9b93c36fd2503f3d122b') }}</el-button></template> -->
                  </el-popconfirm>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ---------------------- -->
      <el-dialog :title="h_i18n('b9245df23437154a2060103e407556dd')" v-model="addVisible" width="70%" center>
        <div class="template_dialog">
          <div class="dialog_search">
            <span>{{ h_i18n('7e217ea649098e03f615a99ae9c692a8') }}</span>
            <el-input :placeholder="h_i18n('717283b275d3f55673435bb403e3afcd')" v-model="templateCode" style="width: 200px" clearable
              class="dialog_input"></el-input>
            <h-button type="primary" @click="searchDialogTable">{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
            <h-button type="primary" style="margin-left: 20px;" @click="openModal2">{{ h_i18n('63edd678c0b5ff3dfa733ce2735c2010') }}</h-button>
           
          </div>
          <div class="dialog_center">
            <div class="cen_nav">
              <div>{{ h_i18n('c926d5670bd8c2d8c8a2e17bfe32416b') }}</div>
              <div>{{ h_i18n('181ed085a630907ddb8f6b6d6e0c9b26') }}</div>
            </div>
            <div class="dialog_table">
              <div class="nodata" v-if="!dialogTableList.length">{{ h_i18n('ba1de94169de5a3b9543c8ed29154a1b') }}</div>
              <div class="item" v-else v-for="item in dialogTableList" @click="clickDialogItem(item)">
                <div class="item_code">{{ item.templateCode }}</div>
                <div class="item_name">{{ item.templateName }}</div>
              </div>
            </div>
            <div class="nomes">
              <span style="color:#999">{{ h_i18n('47360478cf67c095b63ec188ee75fe11') }}</span> <br/>
              <span style="color: red" v-if="!templateItem">{{ h_i18n('d5b1d036097aeb26456527e4bc06f76e') }}</span>
              <div style="color: green" v-else>{{ h_i18n('7bf54e288c1828b84ddbc4ea8a014c51') }}<span style="margin-right: 20px">{{ templateItem.templateCode }}</span>
                <span>{{ templateItem.templateName }}</span>
              </div>
            </div>
          </div>
          <div class="dialog_footer">
            <h-button-group align="right">
              <h-button type="primary" @click="closeDialog">{{ h_i18n('625fb26b4b3340f7872b411f401e754c') }}</h-button>
              <h-button type="primary" @click="submitDialog">{{ h_i18n('38cf16f2204ffab8a6e0187070558721') }}</h-button>
            </h-button-group>
          </div>
        </div>
      </el-dialog>
      <el-dialog width="400px" :title="h_i18n('1141ee22f2f50427af450af9dd6a7eae')" v-model="addVisible2" center>
        <el-input :placeholder="h_i18n('717283b275d3f55673435bb403e3afcd')" v-model="templateCode2" style="width: 200px;margin-bottom: 20px;" clearable
        class="dialog_input"></el-input>
        <el-input :placeholder="h_i18n('09ee1768685b932b57f15cf26cf3eb6b')" v-model="templateName2" style="width: 200px" clearable
              class="dialog_input"></el-input>
              <div class="dialog_footer">
            <h-button-group align="right" style="margin-top: 20px;"> 
              <h-button type="primary" @click="()=>{ addVisible2 = false}">{{ h_i18n('625fb26b4b3340f7872b411f401e754c') }}</h-button>
              <h-button type="primary" @click="submitDialog2">{{ h_i18n('38cf16f2204ffab8a6e0187070558721') }}</h-button>
            </h-button-group>
          </div>
      </el-dialog>
    </inspection-body>
    <inspection-footer>
      <template #body>
        <tr>
          <h-td :title="h_i18n('97d7e7ac40b2a31b9cdbde20c724114b')" colspan="10" style="height: 100px">
            <div>
              <p style="text-align: left;text-indent: 4ch;white-space: normal;">{{ h_i18n('bb75f437133fb1fa63331cc8f0a58eed') }}</p>

              <p style="text-align: left;text-indent: 4ch;white-space: normal;">{{ h_i18n('ad0ca85cdefc015f7357765e030a2c9d') }}</p>

              <el-checkbox style="text-align: center;width: 100%;" v-model="haseRead" label="1">{{ h_i18n('ee1dfef67afe79135693b84b74f6185e') }}</el-checkbox>
            </div>
          </h-td>
        </tr>
      </template>

      <template #footer>
        <h-button-group align="center">
          <h-button type="primary" v-if="!qbTableList.length" @click="addTemplateCard">{{ h_i18n('cde4504ac987144144b5f15417c144bf') }}</h-button>
          <h-button type="primary" @click="onSubmit" :loading="subLoading">{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</h-button>
          <h-button @click="backOrClose()">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
        </h-button-group>
      </template>
    </inspection-footer>
  </h-inspection-page>
</template>






<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

export default {
  name: "TemplateAddTemplate",
  data() {
    return {
      planeDetails: {}, //基本数据
      tableList: [],
      importantList: [],
      checkLevelList: [],
      addVisible: false,
      addVisible2:false,
      dialogTableList: [],
      templateCode: "",
      templateItem: "",
      templateCode2: "",
      templateName2:'',
      templateItem2: "",
      qbTableList: [],
      comTableList: [],
      haseRead:true,
      submitList: [],
      version: "V1.0",
    };
  },
  methods: {
    h_i18n,
  
    synchronizeData() {
      this.$router.push({
        name: "FactoryTemplateSqmTemplateHistory",
        query: {
          name: this.$route.query.name,
          nickName: this.$route.query.nickName,
          mtlNo: this.planeDetails.mtlNo,
          dataFrom: this.$route.query.dataFrom,
          supplyCode: this.$route.query.supplyCode,
        },
      });
    },
    addTemplateCard() {
      this.addVisible = true;
    },
    openModal2(){
      this.addVisible2 = true
      this.templateCode2 = ''
      this.templateName2 = ''
    },
    deleteTemplateCard(v) {
      this.qbTableList.splice(v, 1);
    },
    //数据查询
    getMtlList() {
      let path =
        "/base/baseShipmentTemplate/tempInfo?mtlNo=" +
        this.$route.query.mtlNo +
        "&supplyCode=" +
        this.$route.query.supplyCode;
      if (this.$route.query.type === "2") {
        path =
          "/base/baseShipmentTemplate/tempInfo?mtlNo=" +
          this.$route.query.mtlNo +
          "&supplyCode=" +
          this.$route.query.supplyCode +
          "&version=" +this.version;
      }
      if (this.$route.query.type === "3") {
        path =
          "/base/baseShipmentTemplate/tempInfo?mtlNo=" +
          this.$route.query.mtlNo +
          "&supplyCode=" +
          this.$route.query.supplyCode +
          "&version=" +this.version;
      }
      this.$http({
        url: path,
        method: "get",
      }).then((res) => {
        console.log(res, "企标列表");
        this.closeLoading();
        if (res.data.success) {
          let list = res.data.data;
          if (this.$route.query.type == 2 && !res.data.data.length) {
            // 新增、变更 不判空
            // this.info({
            //   title: "信息提示",
            //   confirmButtonText: '确定',
            //   // cancelButtonText: '否',
            //   message: '请先由海尔工厂外检创建完成专用号检验依据，才可以发起创建出厂模板流程',
            //   callback: (action) => {
            //     console.log(action, "----------------------------")
            //     if (action === "confirm") {
            //       this.$router.back()
            //     } else {
            //       this.$router.back()
            //     }
            //   }
            // })
          }
          this.qbTableList = [...list];
        } else {
          this.info(res.data.msg);
        }
      });
    },
    getComList() {
      let path =
        "/base/baseShipmentTemplate/commonInfo?mtlNo=" +
        this.$route.query.mtlNo +
        "&supplyCode=" +
        this.$route.query.supplyCode;
      if (this.$route.query.type === "2") {
        path =
          "/base/baseShipmentTemplate/commonInfo?mtlNo=" +
          this.$route.query.mtlNo +
          "&shipmentTemplateId=" +
          this.planeDetails.shipmentId +
          "&version=" + this.version + 
          "&supplyCode=" +
          this.$route.query.supplyCode;
      }
      if (this.$route.query.type === "3") {
        path =
          "/base/baseShipmentTemplate/commonInfo?mtlNo=" +
          this.$route.query.mtlNo +
          "&version=" + this.version + 
          "&supplyCode=" +
          this.$route.query.supplyCode;
      }
      this.$http({
        url: path,
        method: "get",
      }).then((res) => {
        console.log(res, "通用要求列表");
        this.closeLoading();
        if (res.data.success) {
          let list = res.data.data;
          // res.data.data.map((item,index)=>{
          //     list[index].frontKey = 'OLD'
          // })
          this.comTableList = [...list];
        } else {
          this.info(res.data.msg);
        }
      });
    },
    getMkl(versionNo) {
      let path =
        "/base/baseShipmentTemplate/mklInfo?mtlNo=" +
        this.$route.query.mtlNo +
        "&supplyCode=" +
        this.$route.query.supplyCode;
        // 变更 tpye是2
      if (this.$route.query.type === "2") {
        path =
          "/base/baseShipmentTemplate/mklInfo?mtlNo=" +
          this.$route.query.mtlNo +
          "&supplyCode=" +
          this.$route.query.supplyCode +
          "&version="+this.version;
      }
      this.$http({
        url: path,
        method: "get",
      }).then((res) => {
        console.log(res, "保存提交信息列表");
        this.closeLoading();
        if (res.data.success) {
          this.submitList = res.data.data;
          if(!versionNo){
            this.version = res.data.data.version
          }
          if(!this.planeDetails.shipmentId){
            this.planeDetails.shipmentId = res.data.data.shipmentId
          }
          this.getMtlList();
          this.getComList();
        } else {
          this.info(res.data.msg);
        }
      });
    },
    inspectionUpdate() {
      this.postThisPageHeight();
    },
    searchByValueTypeId(id) {
      this.$http({
        method: "get",
        url: "/base/basicData/listBaseValues?valueTypeId=" + id,
      }).then((res) => {
        console.log(res.data.data, id, "14检查水平，13重要性");
        if (id == 13) {
          this.importantList = res.data.data;
        }
        if (id == 14) {
          this.checkLevelList = res.data.data;
          console.log(this.checkLevelList);
        }
        // this.getMtlList();
      });
    },
    searchDialogTable() {
      console.log(this.templateCode);
      this.$http({
        method: "get",
        url:
          "/base/baseShipmentTemplate/tempList?templateCode=" + this.templateCode,
      }).then((res) => {
        console.log(res, "查询企标");
        if (res.data.success) {
          this.dialogTableList = res.data.data;
        } else {
          this.info(res.data.msg);
        }
        // this.getMtlList();
      });
    },
    clickDialogItem(item) {
      this.templateItem = item;
      console.log('-----------------',this.templateItem.templateId)
      if(this.qbTableList.some(item=>{
        return item.templateId === this.templateItem.templateId
      })){
        this.info(`【${this.templateItem.templateCode} : ${this.templateItem.templateName}】${h_i18n('111B8CB699B10AB0A706F18BA28837D4')}`)
        this.templateItem = ''
      }
    },
    closeDialog() {
      this.templateItem = "";
      this.addVisible = false;
    },
    submitDialog() {
      console.log(this.templateItem);
      if (!this.templateItem) {
        this.info(h_i18n('3961247a969c40c139238cff7d4a49c4'));
        return false;
      }
      this.$http({
        method: "get",
        url:
          "/base/baseShipmentTemplate/tempInfoById?templateId=" +
          this.templateItem.templateId,
      }).then((res) => {
        console.log(res,'new_new')
        let newItemList = res.data.data
        if(res.data.data&&res.data.data.length){
          // newItemList.map(item=>{
            // item.isSupply = 'Y'
          // })
        }else{
          newItemList[0] = {
          itemId: "",
          itemName: "",
          remark: "",
          importanceProperty: "",
          checkLevel: "",
          aqlProperty: "",
          templateType: "",
          isSupply: "Y",
          isMust: "N",
          // templateName: name,
        };
        }
        console.log(res,newItemList, "查询模板");
        if (res.data.success) {
          // this.dialogTableList = res.data.data
          let obj = {
            templateCode: this.templateItem.templateCode,
            templateId: this.templateItem.templateId,
            templateName: this.templateItem.templateName,
            templateType: this.templateItem.templateType,
            itemList: newItemList,
          };
          let list = this.qbTableList;
          list.push(obj);
          console.log(list);
          this.qbTableList = [...list];
          this.addVisible = false;
          this.success(h_i18n('3fdaeadf0e8a3154ae62784f04138c28'))
          this.templateCode = ''
          this.templateItem = ''
        } else {
          this.info(res.data.msg);
        }
        // this.getMtlList();
      });
    },
    submitDialog2(){
      if(this.templateCode2 == '' || this.templateCode2 == null){
        this.$message.error(h_i18n('1569ee445eb35a5030dcd890db30e6b8'))
        return false
      }
      if(this.templateName2 == '' || this.templateName2 == null){
        this.$message.error(h_i18n('b40055a5bbcb606401f3d790c4234a67'))
        return false
      }
      let newItemList = []
       newItemList[0] = {
          itemId: Math.random(),
          itemName: "",
          remark: "",
          importanceProperty: "",
          checkLevel: "",
          aqlProperty: "",
          templateType: "N",
          isSupply: "Y",
          isMust: "N",
          // templateName: name,
        };
      let obj = {
            templateCode: this.templateCode2,
            templateId:Math.random(),
            templateName: this.templateName2,
            templateType: 'N',
            itemList: newItemList,
          };
          let list = this.qbTableList;
          list.push(obj);
          console.log(list);
          this.qbTableList = [...list];
          this.addVisible2 = false;
          this.addVisible = false;
          this.success(h_i18n('3fdaeadf0e8a3154ae62784f04138c28'))
    },
    addItem(v, n, name) {
      let obj = {
        itemId: "",
        itemName: "",
        remark: "",
        importanceProperty: "",
        checkLevel: "",
        aqlProperty: "",
        templateType: "",
        isSupply: "Y",
        isMust: "N",
        // templateName: name,
      };
      let list = this.qbTableList;
      console.log(list);
      console.log(list[v]);
      list[v].itemList.splice(n + 1, 0, obj);
      this.qbTableList = [...list];
    },
    deleteItem(v, n) {
      let list = this.qbTableList;
      list[v].itemList.splice(n, 1);
      this.qbTableList = [...list];
    },
    addItem2(v) {
      let obj = {
        itemId: "",
        itemName: "",
        importanceProperty: "",
        remark: "",
        checkLevel: "",
        aqlProperty: "",
        isMust: "",
        isSupply: "Y",
        isMust: "N",
        // showDelete:true,
      };
      let list = this.comTableList;
      list.splice(v + 1, 0, obj);
      this.comTableList = [...list];
    },
    deleteItem2(v) {
      let list = this.comTableList;
      list.splice(v, 1);
      this.comTableList = [...list];
    },
    // 提交前验证/
    submitVerify() {
      //将默认的和自定义的分开验证
      //需要检验的集合
      let defaultNeedDetectMap = {
        itemName: h_i18n('222c0f1a6341c9df01ca58fc982db93b'),
        remark: h_i18n('afb44627fabcf435b4633f1f6bd12eb3'),
        importanceProperty: h_i18n('4626e7457839719f5fa1b08526e5e3fd'),
        valueName: h_i18n('0cf684d33849528278363c0e3991cb82'),
        aqlProperty: "AQL",
      };
      defaultList.forEach((v) => {
        for (let o in defaultNeedDetectMap) {
          if (v[o] === "" || v[o] === null) {
            throw new Error(
              `${h_i18n('241d47a3ee97f044c1f043b9ea81855b')}${v.templateName}${h_i18n('28b2cee9eb2b013dfef701a8ac5f72ac')}${v.frontIndex}${h_i18n('2b65f4e5a291d73aef8e5f274c05ded2')}${defaultNeedDetectMap[o]}${h_i18n('f48ab54f727e512ea609812d299c7441')}`
            );
          }
        }
      });
    },
    //总提交
    async onSubmit() {
      this.subLoading = true
      if (!this.haseRead) {
        this.info(h_i18n('fc090ec29467aa95c8456777e9cad400'), h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), {
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          callback: (action) => {
            if (action == "cancel") {
            }
          },
        });
        this.subLoading = false
        return;
      }
      let shipmentIdTemp = ''
      // 如果已经有了，要回传 shipmentId 出厂模板新增除外
      if(this.$route.query.type !== '1'){
          shipmentIdTemp = this.submitList.shipmentId ? this.submitList.shipmentId : undefined
        console.log('this.submitList.shipmentId,,,',this.submitList.shipmentId)
        }else{
          if(this.$route.query.newType === 'new'){ // 新品来的 有shipmentId必须带 // 新品的type改3了 不走这里了
            shipmentIdTemp = this.submitList.shipmentId ? this.submitList.shipmentId : undefined
          }else{
          shipmentIdTemp = undefined
          }
        }
      let obj = {
        // "status": "N",//  N代表是新增,Y代表是变更,T是暂存,3是供应商完善
        materielId: this.submitList.materielId,
        mtlNo: this.planeDetails.mtlNo,
        mtlName: this.planeDetails.mtlName,
        materialGroupId: this.submitList.materialGroupId,
        materialGroupName: this.submitList.materialGroupName,
        matType: this.submitList.matType,
        unit: this.submitList.unit,
        hrIsmoduleInstance: this.submitList.hrIsmoduleInstance,
        deleteStatus: this.submitList.deleteStatus,
        bu: this.submitList.deleteStatus,
        instanceId: this.submitList.instanceId,
        instanceFlag: this.submitList.instanceFlag,
        // "version": "V1.0",
        supplyCodes: [this.$route.query.supplyCode],
        // "supplyName": "青岛量子恒道科技有限公司",
        sybId: this.planeDetails.sybId,
        createFactory: this.planeDetails.sybName,
        dataFrom: "供应商", //
        name: this.$route.query.name,
        nickName: this.$route.query.nickName,
        itemList: this.qbTableList,
        commonItemList: this.comTableList,
        shipmentId : shipmentIdTemp
      };
      for(let i = 0; i <this.qbTableList.length; i++){
          if(this.qbTableList[i].itemList){
            for(let j = 0; j <this.qbTableList[i].itemList.length; j++){
              let item = this.qbTableList[i].itemList[j];
              if(!item.itemName|| !item.remark|| !item.importanceProperty|| !item.checkLevel|| !item.aqlProperty){
                // itemName remark importanceProperty checkLevel aqlProperty

                 this.info(`${h_i18n('a43b5c6f5d35622bb7284f6c92430691')}${this.qbTableList[i].templateName}${h_i18n('9907025c3fab325138738b540799f542')}${j+1}${h_i18n('55eac29b1515b574cf383ba69c7dda0e')}`, h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), {
                  confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
                  })
                  this.subLoading = false
                  return
              }
            }
          }
        }
        //
        if(this.comTableList){
            for(let j = 0; j <this.comTableList.length; j++){
              let item = this.comTableList[j];
              if(!item.itemName|| !item.remark|| !item.importanceProperty|| !item.checkLevel|| !item.aqlProperty){
                // itemName remark importanceProperty checkLevel aqlProperty

                 this.info(`${h_i18n('743c292b4cd3997c2b4414c45c1f0525')}${j+1}${h_i18n('55eac29b1515b574cf383ba69c7dda0e')}`, h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), {
                  confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
                  })
                  this.subLoading = false
                  return
              }
            }
          }

      if (this.$route.query.type === "1") {
        obj.status = "N"
         obj.version = "V1.0"
      }
      if (this.$route.query.type === "2") {
        obj.status = "Y"
         obj.version = this.version
        obj.shipmentId = this.planeDetails.shipmentId;
        obj.auditOpinion = this.planeDetails.auditOpinion;
      }
      if (this.$route.query.type === "3") {
        obj.status = "3"
          obj.version = this.version
        obj.shipmentId = this.planeDetails.shipmentId;
        obj.auditOpinion = this.planeDetails.auditOpinion;
      }
      console.log(obj);
      this.startLoading()
      this.$http({
        method: "POST",
        url: "/base/baseShipmentTemplate/saveTempInfo",
        headers: { "content-type": "application/json" },
        data: obj,
      })
        .then((res) => {
          console.log(res, "提交所有数据");
          if (res.data.success) {
            this.closeLoading();
            this.success(h_i18n('23b62e9cbc868e024b80d2e3fad80ac7'));
            // this.$router.back()
            this.backOrClose()
            // this.success("提交成功", {
            //   confirmButtonText: "确定",
            //   callback: (action) => {
            //     window.history.go(-1)
            //     this.$router.back()
            //   },
            // });
          } else {
            this.error(res.data.msg);
            this.closeLoading();
          }
        })
        .catch((err) => {
          this.closeLoading();
          console.log(err, "保存检验数据失败");
        }).finally(()=>{
          this.subLoading = false
        })
    },
    backOrClose() {
      if(this.$route.query.backUrl && this.$route.query.backUrl=== 'closePage'){
        window.close()
        // 兜底：close 失败时跳回首页或指定页
        setTimeout(() => {
          // window.close() 仍会执行到这里，说明没关成功
          this.$router.replace('/')
        }, 200)
      }else{
        this.$router.back();
      }
    }
  },
  created() { },
  mounted() {
    this.startLoading(h_i18n('26b5bd4947df8be257c59dde927b400c'));
    let list = JSON.parse(this.$route.query.data);
    this.planeDetails = list;
    this.planeDetails.supplyCode = this.$route.query.supplyCode
    console.log(list, "query传参");
    
    setTimeout(() => {
      this.searchByValueTypeId(13);
      this.searchByValueTypeId(14);
      
      if (!list.versionNo) {
        this.getMkl();
      }else{
        this.version = list.versionNo
        this.getMkl();
      }
    
      this.inspectionUpdate();
    }, 1000);
  },
};
</script>

<style src="@/assets/css/new.scss" lang="scss"></style>

<style lang="scss">
.el-input__inner{
    color: #1D2129 !important;
}
.haier-td {
    color: #1D2129 !important;
}
.el-textarea__inner{
  color: #1D2129 !important;
}
  .haier-table-header--logo{
  width: 90px !important;
  height: 34px !important;
  margin-left: 17px;
  img{
    width: 90px !important;
  }
}
.factory_item {
  font-size: 14px;
  display: flex;
  width: 100%;
  background-color: #fff;
  line-height: 40px;
  height: 40px;
  // border-right: 1px solid #ccc;

  .nav_th33 {
    display: flex;
    width: 33%;
  }
  .nav_th50 {
    display: flex;
    width: 50%;
  }
  .nav_left {
   
    color: #4E5969;
    text-align: left;
  }

  .nav_left_befor {
    color: #4E5969;
    margin-left: 16px;
  }

  .nav_right {
    color: #1D2129;
    text-align: left;
    text-indent: 12px;
  }

  .nav_flex {
    display: flex;
  }
}
.vxe-table{
  .vxe-table--body-wrapper{
    overflow-x: hidden !important;
  }
  .vxe-header--column{
    font-weight: normal !important;
    color: #1D2129;
  }
  .vxe-header--row{
    height: 48px !important;
    font-size: 14px;
    border-radius: 8px 8px 0px 0px !important;
    background: rgb(241, 242, 248) !important;
  }
}
.haier-table-header--content{
  height: 56px !important;
  .haier-table-header--left{
    font-size: 24px !important;
    color: #1D2129;
    font-weight: normal !important;
  }
}
.temtable {
  width: 100%;
  min-height: 300px;
  // overflow-y: auto;
  border-top: 1px solid #ccc;

  .table_item {
    .item_nav {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-left: 1px solid #ccc;
      border-right: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      height: 46px;
      line-height: 46px;
      // background-color: #f8f8f8;
    }
  }

  .center {
    text-align: center;
  }

  .table_flex {
    display: flex;
    height: 46px;
    line-height: 46px;
    border-left: 1px solid #ccc;
    border-bottom: 1px solid #ccc;

    .center {
      text-align: center;
    }

    .table_50 {
      width: 50px;
      height: 100%;
      border-right: 1px solid #ccc;

      .el-input__inner {
        width: 90% !important;
        margin-left: 5% !important;
      }
    }

    .table_100 {
      width: 100px;
      height: 100%;
      border-right: 1px solid #ccc;

      .el-input__inner {
        width: 90% !important;
        margin-left: 5% !important;
      }
      .el-textarea{
        .el-textarea__inner{
          width: 98% !important;
          margin-left: 1% !important;
          height: 36px !important;
          padding-top: 6px;
          font-size: 14px;
        }
      }
    }

    .table_150 {
      width: 150px;
      height: 100%;
      border-right: 1px solid #ccc;

      .el-input__inner {
        width: 90% !important;
        margin-left: 5% !important;
      }
      .el-textarea{
        .el-textarea__inner{
          width: 98% !important;
          margin-left: 1% !important;
          height: 36px !important;
          padding-top: 6px;
          font-size: 14px;
        }
      }
    }

    .biaozun {
      width: calc(100% - 608px);
      height: 100%;
      border-right: 1px solid #ccc;

      .el-input__inner {
        width: 98% !important;
        margin-left: 1% !important;
      }
      .el-textarea{
        .el-textarea__inner{
          width: 98% !important;
          margin-left: 1% !important;
          height: 36px !important;
          padding-top: 6px;
          font-size: 14px;
        }
      }
    }
  }
}

.template_dialog {
  .dialog_search {
    height: 40px;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    margin-left: 5%;

    .dialog_input {
      width: 200px !important;
      margin: 0 20px !important;
    }
  }

  .dialog_center {
    .cen_nav {
      width: 90%;
      height: 40px;
      display: flex;
      align-items: center;
      text-align: center;
      margin-left: 5%;
      background-color: #ddedfe;

      div {
        width: 50%;
        height: 100%;
        border: 1px solid #ccc;
        line-height: 40px;
      }
    }

    .dialog_table {
      width: 90%;
      margin-left: 5%;
      border-bottom: 1px solid #ccc;
      max-height: 330px;
      overflow-y: auto;
      margin-bottom: 20px;

      .nodata {
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-left: 1px solid #ccc;
        border-right: 1px solid #ccc;
      }

      .item {
        height: 30px;
        line-height: 30px;
        border: 1px solid #ccc;
        border-bottom: none;
        cursor: pointer;
        display: flex;
        text-indent: 20px;

        .item_code {
          width: 50%;
        }

        .item_name {
          width: 50%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .item:hover {
        background-color: #ddedfe;
      }
    }

    .nomes {
      margin-left: 5%;
    }
  }

  .dialog_footer {
    margin-left: 5%;
  }
}

body {
  overflow: auto !important;
}
.haier-table{
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
}
.haier-inspection-header .haier-table td{
  border: 0px;
}
.haier-inspection-header .haier-table .haier-table-header .haier-table-header--right {
  width: 0 !important;
  border-left: 0px !important;
}

.el-textarea__inner {
  height: 90px !important;
}

.haier-td {
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  text-align: left;
  padding: 4px 10px;
  font-size: 14px;
  height: 35px;
  color: #666;
}

.is-right {
  text-align: right;
}

.input_13 {
  flex: none;
  width: 40px !important;
  transition: all 200ms ease-in-out;
  text-indent: 5px;
}

.input_13 .el-input__inner {
  text-align: center !important;
}

.input_borrow_input {
  text-indent: 10px;
  text-align: left;
}

.check_true {
  width: 200px !important;
  flex: none;
}
</style>